import React from "react";
import { useLanguage } from "@/App";
import { ArrowRight, Phone, Calendar } from "lucide-react";
import { motion } from "framer-motion";

const CTABanner = ({ variant = "default" }) => {
  const { language } = useLanguage();

  const variants = {
    default: {
      title_en: "Ready to Grow Your Business?",
      title_nl: "Klaar Om Je Business Te Laten Groeien?",
      subtitle_en: "Book a free 30-minute strategy call. No obligations, just valuable insights.",
      subtitle_nl: "Plan een gratis 30 minuten strategiegesprek. Geen verplichtingen, alleen waardevolle inzichten.",
      cta_en: "Book Free Consultation",
      cta_nl: "Plan Gratis Adviesgesprek",
      icon: Calendar,
      gradient: "from-[#FF6B00]/20 via-transparent to-purple-500/20"
    },
    urgency: {
      title_en: "Limited Spots Available This Month",
      title_nl: "Beperkte Plekken Beschikbaar Deze Maand",
      subtitle_en: "We take on a maximum of 5 new projects per month to guarantee quality. Secure your spot now.",
      subtitle_nl: "We nemen maximaal 5 nieuwe projecten per maand aan om kwaliteit te garanderen. Reserveer nu je plek.",
      cta_en: "Claim Your Spot",
      cta_nl: "Claim Je Plek",
      icon: Phone,
      gradient: "from-red-500/20 via-transparent to-[#FF6B00]/20"
    }
  };

  const v = variants[variant] || variants.default;
  const Icon = v.icon;

  return (
    <section
      data-testid={`cta-banner-${variant}`}
      className="py-12 bg-[#050505] relative overflow-hidden"
    >
      <div className={`absolute inset-0 bg-gradient-to-r ${v.gradient}`} />
      <div className="absolute inset-0 bg-[#050505]/80" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col md:flex-row items-center justify-between gap-8"
        >
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 bg-[#FF6B00]/10 border border-[#FF6B00]/20 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon size={24} className="text-[#FF6B00]" />
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-1" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
                {language === "nl" ? v.title_nl : v.title_en}
              </h3>
              <p className="text-zinc-400 text-sm md:text-base">
                {language === "nl" ? v.subtitle_nl : v.subtitle_en}
              </p>
            </div>
          </div>

          <a
            href="#contact"
            data-testid={`cta-banner-${variant}-button`}
            className="flex-shrink-0 group inline-flex items-center gap-3 bg-gradient-to-r from-[#FF6B00] to-[#FF4500] text-white px-8 py-4 font-bold hover:shadow-[0_0_30px_rgba(255,107,0,0.4)] transition-all text-sm"
          >
            {language === "nl" ? v.cta_nl : v.cta_en}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABanner;
